import devConfig from "@Env/dev-config";
import prodV1Config from "@Env/prod-v1-config";
import prodV2Config from "@Env/prod-v2-config";
import { FirebaseProject } from "@Runtime/runtime-enums";

const configByEnvironment = {
  [FirebaseProject.Staging]: devConfig,
  [FirebaseProject.ProdV2]: prodV2Config,
  [FirebaseProject.ProdV1]: prodV1Config,
} as const;

const firebaseProject = process.config.FIREBASE_PROJECT || FirebaseProject.ProdV1;

export default configByEnvironment[firebaseProject];
